export default function getObjName(obj) {
    let name;
    if (Q3.labels.live._meshLabels[obj.id] && Q3.labels.live._meshLabels[obj.id]._labels[0]._element.content) {
        name = Q3.labels.live._meshLabels[obj.id]._labels[0]._element.content;
    } else {
        name = obj.name.toString().replace(/_/g, " ");
    }
    return name;
}